<template>
    <div id="claimTopOrder">
        <template v-if="app.template.type === '92fanli'">
            <Header :title="title" >
                <template slot="right">
                    <div class="mybarRight color_999 f8" v-show="toSearchStatus"
                         v-on:click='openSearch'>
                        <span class="iconfont icon-sousuo f12 color_999"></span></div>
                    <div class="mybarRight f8"
                         :class="{'color_green':app.template.style === 'main','color_red':app.template.style === 'main_b','color_yellow':app.template.style === 'main_c'}"
                         v-show="!toSearchStatus" v-on:click='cancelSearch'>取消
                    </div>
                </template>
            </Header>

            <main class="MainCon bottom0">
                <div class="h100">
                    <IScroll @loadBottom="fetchTopOrderClaimList" ref="scroll"
                             :empty="orderData.empty">
                        <div class="mb20">
                            <div class="ml7 mr7">
                                <div class="myContentBox_92fanli mt10 pt10 pb5 rel"
                                     v-for="(item,index) in orderData.list"
                                     :key="index" v-on:click="toClaimOrderDetail(item.id)">
                                    <div class="claimToBtn iconfont icon-mjiantou-copy"></div>
                                    <div class="ml10 mr10 rel">
                                        <p class="myorderTitles">{{item.item_title}}</p>
                                        <div class="f8 lh16 mt7 flexBox"><span
                                                class="flexBox-cell-33">实际金额</span><span
                                                class="flexBox-cell-33">券后付款金额</span><span
                                                class="flexBox-cell-33">返还金额</span></div>
                                        <div class="f8 lh20 flexBox"><span class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.alipay_total_price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.get_pub_share_pre_fee}}</em></span>
                                        </div>
                                        <p class="f8 color_999 lh18">订单状态：<em
                                                :class="{'color_green':app.template.style === 'main','color_red':app.template.style === 'main_b','color_yellow':app.template.style === 'main_c'}">{{item.tk_status_text}}</em>
                                        </p>
                                        <p class="f8 color_999 lh18">订单编号：{{item.trade_id}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template slot="empty">
                            <p class="tc mt12 noneImg"><img src="@/assets/images/orderNone.png" /></p>
                            <p class="tc f10 color_999 lh24">暂无订单哟~</p>
                        </template>
                    </IScroll>
                </div>
            </main>

            <div class="toSearchBoxShadow" v-show="!toSearchStatus" v-on:click='cancelSearch'></div>
            <div class="toSearchBox myborderT" v-show="!toSearchStatus">
                <div class="ml10 mr10 pt5 pb20">
                    <p class="f10 lh20">订单号：</p>
                    <input type="text" class="enrollFormInput mt3" v-model="tradeId"
                           placeholder="请您输入淘宝订单号" />
                </div>
                <div class="ml10 mr10 mb10">
                    <div :class="{'myBtn_92fanli':app.template.style === 'main','myBtn_92fanli_red':app.template.style === 'main_b','myBtn_92fanli_yellow':app.template.style === 'main_c'}"
                         v-on:click='searchSubmit'>确认搜索
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <Header :title="title" >
                <template slot="right">
                    <div class="mybarRight color_999 f8" v-show="toSearchStatus"
                         v-on:click='openSearch'>
                        <span class="iconfont icon-sousuo f12 color_999"></span></div>
                    <div class="mybarRight f8"
                         :class="{'color_red':app.template.style === 'main','color_yellow':app.template.style === 'main_b','color_green':app.template.style === 'main_c'}"
                         v-show="!toSearchStatus" v-on:click='cancelSearch'>取消
                    </div>
                </template>
            </Header>

            <main class="MainCon bottom0">
                <div class="h100">
                    <IScroll @loadBottom="fetchTopOrderClaimList" ref="scroll"
                             :empty="orderData.empty">
                        <div class="mb20">
                            <div class="ml7 mr7">
                                <div class="myContentBox mt10 pt10 pb5 rel"
                                     v-for="(item,index) in orderData.list"
                                     :key="index" v-on:click="toClaimOrderDetail(item.id)">
                                    <div class="claimToBtn iconfont icon-mjiantou-copy"></div>
                                    <div class="ml10 mr10 rel">
                                        <p class="myorderTitles">{{item.item_title}}</p>
                                        <div class="f8 lh16 mt7 flexBox"><span
                                                class="flexBox-cell-33">实际金额</span><span
                                                class="flexBox-cell-33">券后付款金额</span><span
                                                class="flexBox-cell-33">返还金额</span></div>
                                        <div class="f8 lh20 flexBox"><span class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.alipay_total_price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.get_pub_share_pre_fee}}</em></span>
                                        </div>
                                        <p class="f8 color_999 lh18">订单状态：<em
                                                :class="{'color_red':app.template.style === 'main','color_yellow':app.template.style === 'main_b','color_green':app.template.style === 'main_c'}">{{item.tk_status_text}}</em>
                                        </p>
                                        <p class="f8 color_999 lh18">订单编号：{{item.trade_id}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template slot="empty">
                            <p class="tc mt12 noneImg"><img src="@/assets/images/orderNone.png" /></p>
                            <p class="tc f10 color_999 lh24">暂无订单哟~</p>
                        </template>
                    </IScroll>
                </div>
            </main>

            <div class="toSearchBoxShadow" v-show="!toSearchStatus" v-on:click='cancelSearch'></div>
            <div class="toSearchBox myborderT" v-show="!toSearchStatus">
                <div class="ml10 mr10 pt5 pb20">
                    <p class="f10 lh20">订单号：</p>
                    <input type="text" class="enrollFormInput mt3" v-model="tradeId"
                           placeholder="请您输入淘宝订单号" />
                </div>
                <div class="ml10 mr10 mb10">
                    <div :class="{'myBtn_damai':app.template.style === 'main','myBtn_damai_yellow':app.template.style === 'main_b','myBtn_damai_green':app.template.style === 'main_c'}"
                         v-on:click='searchSubmit'>确认搜索
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <Header :title="title" >
                <template slot="right">
                    <div class="mybarRight color_999 f8" v-show="toSearchStatus"
                         v-on:click='openSearch'>
                        <span class="iconfont icon-sousuo f12 color_999"></span></div>
                    <div class="mybarRight f8"
                         :class="{'color_use':app.template.style === 'main','color_red':app.template.style === 'main_b','color_green':app.template.style === 'main_c'}"
                         v-show="!toSearchStatus" v-on:click='cancelSearch'>取消
                    </div>
                </template>
            </Header>

            <main class="MainCon bottom0">
                <div class="h100">
                    <IScroll @loadBottom="fetchTopOrderClaimList" ref="scroll"
                             :empty="orderData.empty">
                        <div class="mb20">
                            <div class="ml7 mr7">
                                <div class="myContentBox mt10 pt10 pb5 rel"
                                     v-for="(item,index) in orderData.list"
                                     :key="index" v-on:click="toClaimOrderDetail(item.id)">
                                    <div class="claimToBtn iconfont icon-mjiantou-copy"></div>
                                    <div class="ml10 mr10 rel">
                                        <p class="myorderTitles">{{item.item_title}}</p>
                                        <div class="f8 lh16 mt7 flexBox"><span
                                                class="flexBox-cell-33">实际金额</span><span
                                                class="flexBox-cell-33">券后付款金额</span><span
                                                class="flexBox-cell-33">返还金额</span></div>
                                        <div class="f8 lh20 flexBox"><span class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.alipay_total_price}}</em></span><span
                                                class="flexBox-cell-33">￥<em
                                                class="f12 b">{{item.get_pub_share_pre_fee}}</em></span>
                                        </div>
                                        <p class="f8 color_999 lh18">订单状态：<em
                                                :class="{'color_use':app.template.style === 'main','color_red':app.template.style === 'main_b','color_green':app.template.style === 'main_c'}">{{item.tk_status_text}}</em>
                                        </p>
                                        <p class="f8 color_999 lh18">订单编号：{{item.trade_id}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template slot="empty">
                            <p class="tc mt12 noneImg"><img src="@/assets/images/orderNone.png" /></p>
                            <p class="tc f10 color_999 lh24">暂无订单哟~</p>
                        </template>
                    </IScroll>
                </div>
            </main>

            <div class="toSearchBoxShadow" v-show="!toSearchStatus" v-on:click='cancelSearch'></div>
            <div class="toSearchBox myborderT" v-show="!toSearchStatus">
                <div class="ml10 mr10 pt5 pb20">
                    <p class="f10 lh20">订单号：</p>
                    <input type="text" class="enrollFormInput mt3" v-model="tradeId"
                           placeholder="请您输入淘宝订单号" />
                </div>
                <div class="ml10 mr10 mb10">
                    <div :class="{'myBtn':app.template.style === 'main','myBtn_red':app.template.style === 'main_b','myBtn_green':app.template.style === 'main_c'}"
                         v-on:click='searchSubmit'>确认搜索
                    </div>
                </div>
            </div>
        </template>

        <div class="goTopBtn">
            <img v-if="btnFlag" src="@/assets/images/backTop.png" v-on:click="toTop">
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import IScroll from '../components/IScroll';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {IScroll, Header},
        data() {
            return {
                title: '认领订单',
                toSearchStatus: true,
                orderData: {
                    empty: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 0
                },
                keywordList: [],
                tradeId: '',
                btnFlag: false,
            }
        },
        computed: {
            ...mapState(['app']),
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }
            this.fetchHotKeyword();
            this.fetchTopOrderClaimList({init: true});
        },
        updated() {
            this.$refs.scroll.$el.addEventListener('scroll', this.scrollToTop);
        },
        methods: {
            fetchHotKeyword: function () {
                let self = this;

                appService.fetchHotKeyword().then((res) => {
                    let {code, data} = res;
                    if (code === 1) {
                        self.keywordList = data;
                    }
                });
            },
            fetchTopOrderClaimList: function ({init = false} = {}) {
                let self = this;

                if (self.orderData.isMore === true && self.orderData.loading === false) {
                    self.orderData.loading = true;

                    appService.fetchTopOrderClaimList({
                        tradeId: self.tradeId,
                        pageNum: self.orderData.pageNum
                    }).then((res) => {
                        let {code, data} = res;
                        if (code === 1) {
                            if (data['data'] !== null && data['data'].length > 0) {
                                if (init) {
                                    self.$refs.scroll.toTop(0);
                                    self.orderData.list = data['data']
                                } else {
                                    for (let i = 0; i < data['data'].length; i++) {
                                        self.orderData.list.push(data['data'][i]);
                                    }
                                }
                                self.orderData.isMore = true;
                                self.orderData.pageNum++;
                            } else {
                                if (self.orderData.list.length > 0) {
                                    self.orderData.isMore = false;
                                } else {
                                    self.orderData.empty = true;
                                }
                            }
                        }
                        self.orderData.loading = false;
                    });
                }
            },
            openSearch: function () {
                this.toSearchStatus = false;
            },
            searchSubmit: function () {
                this.orderData = {
                    empty: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                };
                this.toSearchStatus = true;
                this.fetchTopOrderClaimList();
            },
            cancelSearch: function () {
                this.toSearchStatus = true;
            },
            toClaimOrderDetail: function (id) {
                const route = {
                    name: 'claim-top-order-detail',
                    query: {
                        id
                    }
                };
                this.$router.push(route);
            },
            scrollToTop: function () {
                this.btnFlag = this.$refs.scroll.$el.scrollTop > 180;
            },
            toTop: function () {
                this.$refs.scroll.toTop(0);
            }
        }
    }
</script>

<style scoped>

</style>
